export const APIHelper = {
	handleValidationError(error: any) {
		if (error.response !== undefined && error.response.status === 422) {
			return error.response;
		}
		throw error;
	},
};
